export enum PAYMENT_FLOW {
    BILL_GENERATION = 'bill-generation',
    CARD_PAYMENT = 'card-payment',
}

export const MIN_AMOUNT_VALUE = 500;
export const MAX_AMOUNT_VALUE = 10000000;

export const PDV = 20;
